export default __webpack_public_path__ + "static/media/MSGothic.8c05563b.ttf";